import Vue from 'vue'
import VueRouter from 'vue-router'

import auth from '../utils/authService'

import Home from '../views/Home.vue'
import LtiPay from '../views/Pay.vue'
import LtiBasicTeacher from '../views/lti_basic/Teacher.vue'
import LtiDictionary from '../views/lti_basic/WTS.vue'

import Verify from '../views/Verify.vue'
import Login from '../views/Login.vue'

import Coupon from '../views/admin/Coupon.vue'
import Course from '../views/admin/Course.vue'
import Token from '../views/admin/Token.vue'
import Email from '../views/admin/Email.vue'
import ImportCoupons from '../views/admin/ImportCoupons.vue'
import ManageConsumer from '../views/admin/ManageConsumer.vue'
import ManagePlatform from '../views/admin/ManagePlatform.vue'
import ActivateCourse from '../views/admin/ActivateCourse.vue'
import ManageSproutVideo from '../views/admin/ManageSproutVideo.vue'
import ManageProduct from '../views/admin/ManageProduct.vue'

import Pay from '../views/lti/Pay.vue'
import WTS from '../views/lti/WTS.vue'
import Teacher from '../views/lti/Teacher.vue'
import VideoPicker from '../views/lti/VideoPicker.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    component: Home
  },
  {
    path: '/dictionary',
    component: LtiDictionary
  },
  {
    path: '/lti/wts',
    component: WTS
  },
  {
    path: '/lti/pay',
    component: Pay,
    meta: { title: 'TWA Enrollment' }
  },
  {
    path: '/lti/teacher',
    component: Teacher
  },
  {
    path: '/lti/video-picker',
    component: VideoPicker
  },
  {
    path: '/pay',
    component: LtiPay,
    meta: { title: 'TWA Enrollment' }
  },
  {
    path: '/teacher',
    component: LtiBasicTeacher
  },
  {
    path: '/verify',
    component: Verify,
    meta: { title: 'TWA Enrollment' }
  },
  {
    path: '/login',
    component: Login
  },
  {
    path: '/access_code',
    component: Coupon,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/access_code/:code',
    component: Coupon,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/token',
    component: Token,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/email',
    component: Email,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/course',
    component: Course,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/course/:context_id',
    component: Course,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/about',
    name: 'About',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/import_access_codes',
    component: ImportCoupons,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/import_access_codes/:file',
    component: ImportCoupons,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/manage_consumer',
    component: ManageConsumer,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/manage_platform',
    component: ManagePlatform,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/activate_course',
    component: ActivateCourse,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/activate_course/:token',
    component: ActivateCourse,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/manage_sproutvideo',
    component: ManageSproutVideo,
    meta: { title: 'TWA Admin' }
  },
  {
    path: '/manage_product',
    component: ManageProduct,
    meta: { title: 'TWA Admin' }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  console.log("Routing from '" + from.fullPath + "' to '" + to.fullPath + "'")

  const protected_paths = ['/access_code', '/course', '/token', '/email', '/manage_consumer', '/manage_platform', '/activate_course', '/import_access_codes', '/manage_sproutvideo', '/manage_product']
  const public_paths = ['/lti/wts', '/lti/pay', '/lti/teacher', '/lti/video-picker', '/home', '/verify', '/login', '/dictionary', '/pay', '/teacher', 'consumer']

  if (public_paths.find(path => path === to.path) || auth.isAuthenticated()) {
    return next()
  }

  if (protected_paths.find(path => to.path.startsWith(path))) {
    return next({ path: '/login', query: { redirect: to.fullPath } })
  }

  next({ path: '/' })
})

router.afterEach((to) => {
  // Set page title based on route meta
  document.title = to.meta.title || 'TRUE+WAY ASL'
})

export default router
